import { replacePlaceholders } from "../helpers/replacePlaceholders";

const placeholders = (event = {}) => ({
    organizationName: event.client.organizationName,
    organizationInn: event.client.organizationInn,
});

const getDefaultValue = (value, type) => {
    let _value = value;

    if (type === 'checkbox' || type === 'disclaimer') {
        _value = _value === 'true' ? true : false
    }
    
    return _value
}

export const getRegistrationFields = (event, getProperty) => {
    return event.registrationFields.map((field) => ({
        id: field.id,
        type: field.field.type,
        name: field.field.name,
        required: field.required,
        defaultValue: getDefaultValue(field.field.defaultValue || '', field.field.type),
        label: getProperty(field.field, 'label'),
        description: replacePlaceholders(getProperty(field.field, 'description'), placeholders(event)),
        placeholder: getProperty(field.field, 'placeholder'),
        options: field.field.options?.map((option) => ({
            id: option.id,
            value: option.value,
            label: getProperty(option, 'label'),
        })),
        max: field.field.max,
        min: field.field.min,
        regexp: field.field.regexp,
    })) || [];
};
